// extracted by mini-css-extract-plugin
module.exports = {"container":"ImagePopup_container__2v4-_"};